import React, { useState } from "react";
import styles from "./index.module.scss";
import Textarea from "Components/Textarea";
import { ReactComponent as PaperClip } from "Assets/svg/paperClip.svg";

const NewProjectUpdate = () => {
  const [textField, updateTextField] = useState("");

  return (
    <div className={styles.container}>
      <Textarea
        value={textField}
        name="textField"
        label="Enter product update"
        action={(e) => updateTextField(e.target.value)}
      />

      <div className={styles.buttonContainer}>
        <button className={styles.attachButton}>
          <PaperClip />
          <span>Attach files</span>
        </button>
        <button className={styles.submitButton}>Submit</button>
      </div>
    </div>
  );
};

export default NewProjectUpdate;
